module.exports = __webpack_public_path__ + "./fonts/MuseoSans_500.otf";